import React from 'react';
import { ContentSpacer } from '../../../../../../global/components/layout/generic-content-spacer';
import { DividerSection } from '../../../../../../global/components/layout/divider-section';
import { MemberEnrolledCoverage } from '../models/member-coverage-model';
import { getLetterMonthDate } from '../../../../../../global/helpers/date-helpers';
import { NewHireProps } from '../../../../models/arc-epi-props';
import { LabelAndValue } from '../../../../../../global/components/data-display/label-value';
import { getCurrencyFormat } from '../../../../../../global/helpers/format-helpers';
import { CoveragePlans, DeclinedValue } from '../../enrollment/models/coverage-models';


interface Props {
	groupLabel: string;
	plan: MemberEnrolledCoverage;
	settings: NewHireProps;
	declineMessage?: string;
	pendingPlan?: CoveragePlans;
	selectedPendingPlan?: string;
}
export function MemberSelectedPlanDisplay(props: Props) {

	const { groupLabel, plan, settings, declineMessage, pendingPlan, selectedPendingPlan } = props;


	if (!plan?.plan?.name && !(pendingPlan?.plans?.length > 0)) return null;


	function RenderPendingPlan() {

		const matchedPlan = pendingPlan?.plans?.find(p => p?.code === selectedPendingPlan);

		return (
			<>
				{
					!selectedPendingPlan || selectedPendingPlan === DeclinedValue ?
						declineMessage :
						<ContentSpacer>
							<h4>{matchedPlan?.name}</h4>
						</ContentSpacer>
				}
				{
					selectedPendingPlan && selectedPendingPlan !== DeclinedValue &&
					<ContentSpacer>
						{matchedPlan?.volume && <LabelAndValue label={settings?.volumeLabel} value={getCurrencyFormat(matchedPlan?.volume)} />}
						{matchedPlan?.rate && < LabelAndValue label={settings?.rateLabel} value={getCurrencyFormat(matchedPlan?.rate)} />}
						{pendingPlan?.effective_date && < LabelAndValue label={settings?.effectiveDateLabel} value={getLetterMonthDate(pendingPlan?.effective_date)} />}

					</ContentSpacer>
				}
			</>
		);
	}

	function RenderCompletedPlan() {

		return (
			<>
				<ContentSpacer>
					<h4>{plan?.plan?.name}</h4>
				</ContentSpacer>

				<ContentSpacer>
					{plan?.plan?.volume && <LabelAndValue label={settings?.volumeLabel} value={getCurrencyFormat(plan?.plan?.volume)} />}
					{plan?.plan?.rate && < LabelAndValue label={settings?.rateLabel} value={getCurrencyFormat(plan?.plan?.rate)} />}
					{plan?.effective_date && < LabelAndValue label={settings?.effectiveDateLabel} value={getLetterMonthDate(plan?.effective_date)} />}
				</ContentSpacer>
			</>
		);
	}

	return (
		<>
			<DividerSection sectionText={groupLabel} removeDivider >
				{
					pendingPlan?.plans?.length > 0 && RenderPendingPlan()

				}

				{
					plan?.plan?.name && RenderCompletedPlan()
				}
			</DividerSection>
		</>
	);
}


MemberSelectedPlanDisplay.defaultProps = {
	pendingPlan: null,
	selectedPendingPlan: null,
	declineMessage: null,
};